import type { LOGIN_PROVIDERS } from 'types/enums.ts';

import type { AuthFlow } from './api';
import type { Languages } from './translator';

export enum STORAGE_KEYS {
  REFRESH_TOKEN = 'refreshToken',
  LANGUAGE = 'language',
}

export type STORAGE_VALUES = {
  [STORAGE_KEYS.REFRESH_TOKEN]: {
    refreshToken: string;
    provider?: LOGIN_PROVIDERS | null;
    authFlow?: AuthFlow | null;
  };
  [STORAGE_KEYS.LANGUAGE]: {
    language: Languages;
  };
};
